var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"id":"main"}},[_c('div',{staticClass:"tuo tuo1",on:{"mousedown":_vm.move}},[_vm._v("\n    1\n  ")]),_c('div',{staticClass:"tuo tuo2",on:{"mousedown":_vm.move}},[_vm._v("\n    2\n  ")]),_c('div',{staticClass:"tuo tuo3",on:{"mousedown":_vm.move}},[_vm._v("\n    3\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }